import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./VangalTestimonials.css";

export default function VangalTestimonials() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreen(); // initial check
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const settings = {
    dots: !isMobile,
    infinite: true,
    speed: 600,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    arrows: false,
    swipeToSlide: true,
    centerMode: isMobile,
    centerPadding: isMobile ? "30px" : "0px",
    autoplay: isMobile,
    autoplaySpeed: 3000
  };

  const testimonials = [
    {
      id: 1,
      title: "“Pure and Authentic Taste!”",
      text:
        "Vangal Dairies' ghee and butter remind me of the taste I grew up with. The quality is unmatched and feels truly homemade.",
      name: "Priya Raman",
      role: "Customer from Chennai",
      img: "https://i.pravatar.cc/100?img=12"
    },
    {
      id: 2,
      title: "“Best Dairy Products in Tamil Nadu”",
      text:
        "The paneer is extremely fresh and soft. Vangal Dairies maintains amazing purity and consistency in all their products.",
      name: "Karthik Murali",
      role: "Restaurant Owner, Namakkal",
      img: "https://i.pravatar.cc/100?img=32"
    },
    {
      id: 3,
      title: "“High Quality & No Preservatives”",
      text:
        "I trust Vangal products because they are natural and preservative free. My family loves their curd and ghee.",
      name: "Meena Shankar",
      role: "Homemaker, Trichy",
      img: "https://i.pravatar.cc/100?img=45"
    },
    {
      id: 4,
      title: "“Taste That Feels Like Home”",
      text:
        "Their butter melts perfectly and has a wonderful aroma. Truly artisanal dairy products!",
      name: "Suresh Kumar",
      role: "Chef, Coimbatore",
      img: "https://i.pravatar.cc/100?img=18"
    }
  ];

  return (
    <section className="vangal-testimonials-section">
      <p className="vangal-testimonials-subtitle">TESTIMONIALS</p>
      <h2 className="vangal-testimonials-title">What our customers say</h2>

      <Slider {...settings} className="vangal-testimonials-slider">
        {testimonials.map(item => (
          <div key={item.id} className="vangal-testimonial-card">
            <h3 className="vangal-testimonial-heading">{item.title}</h3>
            <p className="vangal-testimonial-text">{item.text}</p>

            <div className="vangal-testimonial-user">
              <img src={item.img} alt={item.name} />
              <div>
                <h4>{item.name}</h4>
                <p>{item.role}</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}
